import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./Message.module.css";
import { BRAND } from "../../../data/brand";
import { IMAGES } from "../../../data/images";
import { Animate, Parallax } from "../../animations";

const Message = () => {
  return (
    <section className={styles.message}>
      <div className={styles.messageInner}>
        <Animate variant="slideRight" className="w-full lg:w-auto flex justify-center">
          <Parallax speed={0.18}>
            <img
              src={IMAGES.founderPortrait}
              alt={BRAND.founder}
              className={styles.founderImage}
            />
          </Parallax>
        </Animate>
        <Animate variant="slideLeft" delay={120} className={styles.messageContent}>
          <hr className={styles.divider} />
          <h3 className={styles.messageHeading}>Founder's Message</h3>
          <h1 className={styles.founderName} id="heading-large">
            {BRAND.founder}
          </h1>
          <p className={styles.messageParagraph}>
            When I started Ever Sky Overseas in {BRAND.foundedYear}, I had one
            mission: to make world-class education accessible to every deserving
            Indian student, regardless of their background. Having navigated the
            complex study-abroad process myself, I understood the challenges —
            confusing applications, visa rejections, and lack of trustworthy guidance.
          </p>
          <p className={styles.messageParagraph}>
            Today, our team has helped over 5,000 students achieve their dreams.
            We don't just process applications — we build futures. Every student who
            walks through our doors receives personalized attention, honest advice,
            and unwavering support until they're settled in their new country.
          </p>
          <NavLink to="/about">
            <button className={styles.ourTeamButton}>Meet Our Team</button>
          </NavLink>
        </Animate>
      </div>
    </section>
  );
};

export default Message;
